var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDarPending = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "url(#paint0_linear_47687_220823)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.9997 5.3335C10.6811 5.3335 9.3922 5.72449 8.29588 6.45703C7.19955 7.18957 6.34506 8.23077 5.84048 9.44894C5.3359 10.6671 5.20387 12.0076 5.46111 13.3008C5.71834 14.594 6.35328 15.7819 7.28563 16.7142C8.21798 17.6466 9.40587 18.2815 10.6991 18.5387C11.9923 18.796 13.3327 18.6639 14.5509 18.1594C15.7691 17.6548 16.8103 16.8003 17.5428 15.704C18.2753 14.6076 18.6663 13.3187 18.6663 12.0002C18.6663 11.1247 18.4939 10.2578 18.1589 9.44894C17.8238 8.6401 17.3328 7.90517 16.7137 7.28612C16.0947 6.66706 15.3597 6.176 14.5509 5.84097C13.7421 5.50593 12.8752 5.3335 11.9997 5.3335ZM12.6663 12.0002C12.6669 12.0879 12.65 12.1749 12.6169 12.2561C12.5837 12.3373 12.5348 12.4112 12.473 12.4735L10.473 14.4735C10.3455 14.5827 10.1814 14.6398 10.0136 14.6333C9.84586 14.6268 9.6867 14.5573 9.56797 14.4385C9.44924 14.3198 9.37968 14.1606 9.3732 13.9929C9.36672 13.8251 9.42379 13.661 9.53301 13.5335L11.333 11.7268V8.66683C11.333 8.49002 11.4032 8.32045 11.5283 8.19543C11.6533 8.0704 11.8229 8.00016 11.9997 8.00016C12.1765 8.00016 12.3461 8.0704 12.4711 8.19543C12.5961 8.32045 12.6663 8.49002 12.6663 8.66683V12.0002Z",
  fill: "white"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_47687_220823",
  x1: 6.5,
  y1: 1,
  x2: 16,
  y2: 23,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EDC1DC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E0BCFD"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDarPending);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dar_pending.ce59b5ca43067292aebc4ba3b42d971d.svg";